<template>
  <v-row>
    <template v-for="(item, i) of aboutNetwork">
      <v-col :key="i" cols="6" md="4">
        <NetworkCard :img="item.image_path" @onPress="openLink(item.url)" />
      </v-col>
    </template>
  </v-row>
</template>

<script>
import NetworkCard from "../cards/NetworkCard";
import { mapState } from 'vuex';
export default {
  components: {
    NetworkCard
  },
  computed: {
    ...mapState({
      aboutNetwork: state => state.About.network,
    })
  },
  methods: {
    openLink(url) {
      if (url) {
        window.open(url);
      }
    }
  }
};
</script>

<style>
</style>
